import React from 'react';
import {Link} from 'react-router-dom';

class PreviewOrganization extends React.Component {
    render() {
        return (
            <div className="main-content-block">
                <div className="nodebook-preview bg transform">
                    <div className="nodebook-preview-image-wrap">
                        <img src={this.props.info.avatar} alt="avatar" />
                        {
                        //<div className="nodebook-preview-image"></div>
                        }
                    </div>
                    <div className="nodebook-preview-content">
                        <span className="date">10 hours ago</span>
                        <div className="nodebook-preview-title">
                            <Link to={"/organization/"+this.props.info.id}>
                                <h2 className="special">{this.props.info.name}</h2>
                            </Link>
                            {
                            (this.props.info.author)
                            ?<Link className="author" to={"/user/"+this.props.info.author}>
                                @{this.props.info.author}
                            </Link>
                            :null
                            }
                        </div>
                        <div className="nodebook-preview-text hidden">
                            <p>
                                {this.props.info.description}
                            </p>
                        </div>
                        <div className="nodebook-preview-stats">
                            <div className="nodebook-preview-stats-item half">
                                <span className="icon icon-like"></span>33 likes
                            </div>
                            <div className="nodebook-preview-stats-item half">
                                <span className="icon icon-view"></span>{this.props.info.views} views
                            </div>
                            <div className="nodebook-preview-stats-item half">
                                <span className="icon icon-comment"></span>2 comments
                            </div>
                            <div className="nodebook-preview-stats-item half">
                                <span className="icon icon-follower"></span>{(this.props.info.followers)?this.props.info.followers:0} followers
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default PreviewOrganization;



// WEBPACK FOOTER //
// ./src/components/PreviewOrganization.js